export default ({...props}) => {
  const {size, space} = props.theme
  return `
    &[ap_name="edit_location_cancel_popup"],
    &[ap_name="location_too_far_popup"],
    &[ap_name="notify_prefs_cancel_popup"] {
      & .MuiDialog-paper {
        padding: ${space(1.25)}px; 

        @media screen and  (max-width: 480px) {
          margin: ${space(0.4)}px;
        }
      }

      & .MuiDialogActions-root {
        & button[ap_atom_name="buttonAtom"] {
          min-width: ${size(17.5)}px;

          @media screen and (max-width: 480px) {
            min-width: ${size(12.5)}px;
          }
        }
      }
    }   
    `
}
